module.exports = __webpack_public_path__ + "img/water.5a588425.png";